import Vue from 'vue';
import { GameController } from '../controllers/game'

Vue.use({
    install(Vue) {
        Vue.prototype.ctrl_game = function() {
            return GameController;
        }

        Vue.prototype.set_ctrl_game = function(ctx) {
            GameController.setCtx(ctx)
        }
    }
});